export default __webpack_public_path__ + "716cfaefd2c50da76899ff9450b2de7e.ttf";